import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDraftEntryStore } from '@/pages/Schedule/stores';
import type { ScheduleParams } from '@/pages/Schedule/types';
import { useEntry } from '../useEntry';

/**
 * Fetch the entry that was direct-linked to and open it in the entry modal.
 *
 * Note that we need a dedicated query to fetch the entry because there is no
 * guarantee that the entry exists in the EntriesContext. For example, the
 * underlying schedule may show the week of Aug 1st but the entry starts on
 * Dec 1st
 */
export const useOpenEntryModal = () => {
  const { entryId, instanceTimestamp } = useParams<ScheduleParams>();
  const editDraftEntry = useDraftEntryStore((store) => store.editDraftEntry);
  const data = useEntry(entryId, instanceTimestamp);
  const didOpen = useRef(false);

  useEffect(() => {
    // `data` can change if the entry is updated in the modal which
    // will cause the modal to re-open on close, so make sure this
    // logic only runs once
    if (data && !didOpen.current) {
      editDraftEntry(data.entry, data.instance);
      didOpen.current = true;
    }
  }, [data, editDraftEntry]);
};
